import React, { Component } from 'react';
import DownloadReportPortfolio from './DownloadReportPortfolio';

class DownloadReport extends Component {

  render() {
    return (
      <div >
        <DownloadReportPortfolio />
      </div>
    );
  }
}

export default DownloadReport;
